import React, {Component} from "react";
import WarehousePanelSetContainer from "./inventory/WarehousePanelSetContainer";
import StockPanelSetContainer from "./inventory/StockPanelSetContainer";
import AvailabilityPanelSetContainer from "./shipping/AvailabilityPanelSetContainer";
import "./PanelContainer.scss";

class PanelContainer extends Component {

  render() {

    return (
      <div className="PanelContainer">
        <div className="header"/>
        <Conditional render={this.props.context === "stock"}>
          <StockPanelSetContainer />
        </Conditional>
        <Conditional render={this.props.context === "availability"}>
          <AvailabilityPanelSetContainer />
        </Conditional>
        <Conditional render={this.props.context === "warehouses"}>
          <WarehousePanelSetContainer />
        </Conditional>
      </div>
    )
  }

}


const Conditional = (props) => {
  if (!props.render) return null;
  return props.children;
}




export default PanelContainer;